export default __webpack_public_path__ + "static/media/etc-shop.a64d6044.png";